import type { SVGProps } from 'react';

const TrackingPathSvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <circle cx={8} cy={25} r={2.5} stroke="currentColor" strokeWidth={2} />
    <path
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeDasharray="0.5 3.5"
      d="M13 25h5a3 3 0 0 0 0-6h-5a3 3 0 0 1 0-6h2"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23 17.5s-5-5.2-5-8.5a5 5 0 0 1 10 0c0 3.3-5 8.5-5 8.5Zm0-6.7a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6Z"
      clipRule="evenodd"
    />
  </svg>
);
export default TrackingPathSvgIcon;
